/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TemplateFieldValue } from './TemplateFieldValue';
import {
    TemplateFieldValueFromJSON,
    TemplateFieldValueFromJSONTyped,
    TemplateFieldValueToJSON,
} from './TemplateFieldValue';

/**
 * 
 * @export
 * @interface DocumentTemplatePrefilled
 */
export interface DocumentTemplatePrefilled {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    physician_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    template_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    title?: string;
    /**
     * 
     * @type {Array<TemplateFieldValue>}
     * @memberof DocumentTemplatePrefilled
     */
    values?: Array<TemplateFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplatePrefilled
     */
    bundle?: string;
}

/**
 * Check if a given object implements the DocumentTemplatePrefilled interface.
 */
export function instanceOfDocumentTemplatePrefilled(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentTemplatePrefilledFromJSON(json: any): DocumentTemplatePrefilled {
    return DocumentTemplatePrefilledFromJSONTyped(json, false);
}

export function DocumentTemplatePrefilledFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentTemplatePrefilled {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'physician_id': !exists(json, 'physician_id') ? undefined : json['physician_id'],
        'template_id': !exists(json, 'template_id') ? undefined : json['template_id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(TemplateFieldValueFromJSON)),
        'bundle': !exists(json, 'bundle') ? undefined : json['bundle'],
    };
}

export function DocumentTemplatePrefilledToJSON(value?: DocumentTemplatePrefilled | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'physician_id': value.physician_id,
        'template_id': value.template_id,
        'title': value.title,
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(TemplateFieldValueToJSON)),
        'bundle': value.bundle,
    };
}

